// Generated by /client/scripts/generate-icon-components.mjs
// DO NOT EDIT DIRECTLY

import type React from "react";

import messageSmileSquareIcon from "@/assets/icons/message-smile-square.svg";

import { Icon, type IconProps } from "../Icon/Icon";

type MessageSmileSquareIconProps = Omit<IconProps, "name">;

export function MessageSmileSquareIcon(props: MessageSmileSquareIconProps): React.ReactNode {
  return <Icon name={messageSmileSquareIcon} {...props} />;
}
